
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddressDtoFormGroup() {
return new FormGroup({
    objectStreet: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    objectZip: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    objectCity: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    objectCanton: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
})
;
}
      